export const PRIJEMROBE_V1ResourcesDE: PRIJEMROBE_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  input: {
    signatureTitle: "Unterschrift",
    datum: {
      label: "Datum",
      placeholder: "Bitte geben Sie das Datum ein",
      name: "datum",
    },
    ispravnaPosiljka: {
      label: "Ist die Sendung fehlerhaft?",
      placeholder: "Bitte geben Sie an, ob die Sendung fehlerhaft ist",
      name: "ispravnaPosiljka",
    },
    dokument: {
      label: "Dokumente",
      placeholder: "Bitte geben Sie die Dokumente ein",
      name: "dokument",
      description: () => (
        <>
          <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
          <span className="text-muted font-13">Nur Bilder, max 6MB</span>
        </>
      ),
    },
    korektivnaMjera: {
      label: "Korrekturmaßnahme",
      placeholder: "Bitte geben Sie die Korrekturmaßnahme ein",
      name: "korektivnaMjera",
    },
    potpisPrimalac: {
      label: "Bitte unterschreiben Sie die Lieferung",
      placeholder: "",
      name: "potpisano",
    },
    primalac: {
      label: "Lieferant",
      placeholder: "Bitte geben Sie den Lieferantennamen / Firmennamen ein",
      name: "primalac",
    },
    primjedba: {
      label: "Bemerkung",
      placeholder: "Bitte geben Sie eine Bemerkung ein",
      name: "primjedba",
    },
    temperatura: {
      label: "Temperatur",
      placeholder: "Bitte geben Sie die Temperatur ein",
      name: "temperatura",
    },
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
};

interface InputField {
  label: string;
  placeholder: string;
  name: string;
  description?: () => JSX.Element;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ispravnaPosiljka: InputField;
  dokument: InputField;
  korektivnaMjera: InputField;
  potpisPrimalac: InputField;
  primalac: InputField;
  primjedba: InputField;
  temperatura: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface PRIJEMROBE_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
